<template>
  <el-card class="wrapper">
    <div class="wrapperBoxClick">
      <el-col
        :xl="{ span: 10, offset: 0 }"
        :lg="{ span: 10, offset: 0 }"
        :md="{ span: 10, offset: 0 }"
        :sm="{ span: 10, offset: 0 }"
        :xs="{ span: 24, offset: 0 }"
      >
        <div
          class="video-card-container"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <div class="video-card list-item">
            <!-- Video thumbnail (or default) -->
            <!-- <thumbnail-image
              v-if="videoInfo.status == 'ready'"
              class="videoThumb videoThumb--active"
              :src="playPreview ? previewLink : thumbnailLinkVideoPhoto"
              :fallback="fallbackImage"
              alt="Video Preview"
              @mouseover="playPreview = true"
              @mouseleave="playPreview = false"
            /> -->
            <thumbnail-image
              :src="info.thumbnailLink"
              :fallback="fallbackImage"
              class="video-card-thumb"
              alt="thumbnail"
            />
            <div class="video-card-info">
              <div class="video-card-info-param">
                <span class="video-card-info-label">Duration:</span>
                <span class="video-card-info-value">{{ durationLine }}</span>
              </div>
              <div class="video-card-info-param">
                <span class="video-card-info-label">Time:</span>
                <span class="video-card-info-value">{{ startDateTimeLine }} - {{ endDateTimeLine }}</span>
              </div>
              <!-- <div class="wrapper-flex">
                <span class="videoInfoLabel">to</span>
                <span class="color-text">{{ endDateTimeLine }}</span>
              </div> -->
              <!-- <div class="wrapper-flex">
                <span class="videoInfoLabel">Title:</span>
                <span class="color-text">{{ videoTitle }}</span>
              </div> -->
              <!-- Preview button -->
              <div class="video-card-info-buttons">
                <el-button
                  type="primary"
                  title="Watch Video"
                  plain
                  size="mini"
                  class="videoItemButton"
                  @click="startPreview"
                >
                  <television title="Watch Video" class="videoItemIcon" />
                </el-button>
              </div>
            </div>
            <div class="video-card-side-buttons">
              <!-- Remove video button -->
              <el-button
                type="danger"
                title="Delete Video"
                size="mini"
                class="videoItemButton"
                @click="deleteRanges"
              >
                <close-thick title="Delete Video" class="videoItemIcon" />
              </el-button>
            </div>
          </div>
        </div>
      </el-col>
    </div>
  </el-card>
</template>

<script src="vue-slicksort/dist/umd/vue-slicksort.js"></script>
<script>
import { ElementMixin } from "vue-slicksort";

import fallbackImage from "@/assets/images/empty.jpg";
import { mapState } from "vuex";
import Television from "vue-material-design-icons/Television.vue";
import { getDurationTimeline, getDateAndTimeLine } from "@/utils/time.js";
import ThumbnailImage from "@/components/timeline/thumbnails/ThumbnailImage.vue";
import CloseThick from "vue-material-design-icons/CloseThick.vue";
import Autorenew from "vue-material-design-icons/Autorenew.vue";
export default {
  name: "MediaList",
  components: {
    ThumbnailImage,
    CloseThick,
    Television,
    fallbackImage
    // Autorenew,
  },
  mixins: [ElementMixin],
  props: {
    index: {
      type: Number,
      required: true
    },
    item: {
      type: Object
    },
    mediaCuts: {
      type: Array
    },
    info: {
      type: Object
    },
    videoInfo: {
      type: Object
    }
  },
  fallback: fallbackImage,
  data() {
    return {
      fallbackImage: fallbackImage,
      infoVIdeo: this.info.ranges
    };
  },
  computed: {
    ...mapState({
      timezone: state => state.timezone.timezone
    }),
    sheckRanges() {
      return this.info.ranges.reduce((sum, x) => {
        return sum + (x[1] - x[0]);
      }, 0);
    },
    durationLine() {
      return getDurationTimeline(this.sheckRanges);
    },
    startDateTimeLine() {
      let getStartTime = +new Date(this.videoInfo.startTime);
      let timeFrom = getStartTime + this.item.ranges[0][0];
      return getDateAndTimeLine(timeFrom, this.timezone);
    },
    endDateTimeLine() {
      let getStartTime = +new Date(this.videoInfo.startTime);
      let timeTo = getStartTime + this.item.ranges[0][1];
      return getDateAndTimeLine(timeTo, this.timezone);
    },
    // // @vuese
    // // Video start time in format DD-MM-YYYY HH:mm:ss
    // startDateTimeLine() {
    //   return getDateAndTimeLine(this.videoInfo.startTime, this.timezone);
    // },
    // // @vuese
    // // Video end time in format DD-MM-YYYY HH:mm:ss
    // endDateTimeLine() {
    //   return getDateAndTimeLine(this.videoInfo.endTime, this.timezone);
    // },
    videoTitle() {
      return this.info.title;
    },
    checkIdVideo() {
      return this.info.source;
    }
  },
  mounted() {
    let getStartTime = +new Date(this.videoInfo.startTime);
    let timeFrom = getStartTime + this.item.ranges[0][0];
    console.log("timeFrom", getDateAndTimeLine(timeFrom), this.timezone);
    let timeTo = getStartTime + this.item.ranges[0][1];
    console.log("timeTo", getDateAndTimeLine(timeTo), this.timezone);
  },
  methods: {
    deleteRanges(e) {
      // this.$emit("deleteRange", deleteRangeVideo)
      e.stopPropagation();
      this.$emit("deleteRange");
    },
    counterTimeItem() {
      let getStartTime = +new Date(this.videoInfo.startTime);
      let timeFrom = getStartTime + ranges[0][0];
      console.log("timeFrom", timeFrom);
      let timeTo = getStartTime + ranges[0][1];
      console.log("timeTo", timeTo);
    },
    startPreview() {
      this.$emit("preview");
      this.$emit("selectVideoId", this.checkIdVideo);
    }
  }
};
</script>

<style scoped>
.wrapper-flex {
  text-align: left;
}

.el-button--mini {
  padding: 0px;
}

.videoInfoWrapper {
  width: 100%;
}

.color-text {
  /* font-family: sans-serif; */
  width: 120px;
  color: #b2b2b2;
  font-size: 13px;
}

.wrapper-content {
  padding: 10px;
  display: flex;
  flex-direction: column;
  user-select: none;
}

.wrapper {
  z-index: 9999;
  display: flex;
}

.thumb-img {
  width: 380px;
  height: 120px;
}

.el-col-24 {
  width: 100%;
}
.wrapper {
  /* widows: 100%; */
  background: #303133;
  margin-bottom: 5px;
}

.el-card__body {
  width: 100%;
}

.wrapperBoxClick {
}
/** thumbs */
.videoThumbContainer {
  position: relative;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.videoInfoLabel {
  margin-right: 5px;
  display: inline-block;
  color: #ffffff;
  font-size: 13px;
  /* font-family: sans-serif; */
}

.videoThumbOverlay {
  position: absolute;
  z-index: var(--video-thumb-overlay-z);
  right: 0;
  top: 0;
  user-select: none;
  cursor: pointer;
}
.videoThumbOverlay__icon {
  margin-right: 4px;
  margin-top: 4px;
}
.videoThumbOverlay__icon svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.removeButtonflex {
  display: flex;
  width: 100%;
  justify-content: space-between;
}

.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}

.videoInfoWrapper {
  display: flex;
  width: 100%;
}

.videoInfoStyleColumn {
  margin: 10px 0 0 30px;
}


/** refactored card styles */

.video-card-container {
  position: relative;
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
}

.video-card {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  overflow: hidden;
}

.video-card-thumb {
  /*
  width: 100%;
  height: 100%;
  position: relative;
  */
  height: 160px;
  width: 245px;
  overflow: hidden;
  flex-shrink: 0;
}

.video-card-thumb >>> img {
  display: block;
  object-fit: contain;
}

.video-card-thumb-overlay {
  position: absolute;
  z-index: var(--video-thumb-overlay-z);
  right: 0;
  top: 0;
  user-select: none;
  cursor: pointer;
}
.video-card-thumb-overlay__icon {
  margin-right: 4px;
  margin-top: 4px;
}
.video-card-thumb-overlay__icon svg {
  width: 1.5rem !important;
  height: 1.5rem !important;
}

.video-card-info {
  margin: 5px 0 10px 20px;
  flex-grow: 1;
  overflow: hidden;
}

.video-card-info-param {
  justify-self: start;
  text-align: start;
  margin-bottom: 4px;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.video-card-info-label {
  /* font-family: sans-serif; */
  /* width: 5rem; */
  color: #b2b2b2;
  margin-right: 5px;
  /* display: inline-block; */
}

.video-card-info-value {
  /* font-family: sans-serif; */
  margin-right: 5px;
  /* display: inline-block; */
  color: white;
  /* width: 130px; */
}

.video-card-side-buttons {
  align-self: flex-start;
}
.video-card-info-buttons {
  text-align: left;
  margin-top: 20px;
}

@media only screen and (max-width: 1500px) and (min-width: 1200px) {
  .video-card-thumb {
    height: 150px;
    width: 200px;
    overflow: hidden;
    flex-shrink: 0;
  }
}

@media only screen and (max-width: 1200px) and (min-width: 880px) {
  .video-card {
    flex-direction: column;
  }
  .video-card-thumb {
    max-width: 100%;
  }
  .video-card-info {
    margin: 15px 5px 5px;
    align-self: stretch;
    font-size: 80%;
  }
  .video-card-info-param {
    flex-direction: row;
  }
  .video-card-info-label {
    margin-right: 5px;
  }

  .video-card-side-buttons {
    align-self: flex-end;
    margin-top: -34px; /* hacky way */
  }
}

/** refactored card styles end */

.button-color-yellow {
  color: #e6a23c;
  background: #6b645a;
  border-color: #947950;
}
.button-color-yellow:hover {
  color: #6b645a;
  background: #e6a23c;
  border-color: #947950;
}

.button-color-green {
  color: #ffffff;
  background-color: #67c23a;
  border-color: #67c23a;
}

.button-color-green:hover {
  background: #65ae41;
  border-color: #65ae41;
  color: #ffffff;
}

.margin-text {
  /* margin: 0 150px 0 0; */
  position: absolute;
  left: 10px;
  top: 6px;
}

.style-button {
  padding: 0px 15px;
  font-size: 11px;
  border-radius: 4px;
  height: 30px;
  align-self: flex-end;
}

.videoThumb {
  width: 100%;
  height: 100%;
  position: relative;
}

.align-items {
  display: flex;
  align-items: baseline;
  padding: 10px;
  width: 100%;
  justify-content: flex-end;
}

.videoInfoParam {
  justify-self: start;
  text-align: start;
  margin-bottom: 4px;
  font-size: 14px;
  display: flex;
  width: 100%;
}

.videoInfoValue {
  margin-right: 5px;
  display: inline-block;
  color: #b2b2b2;
  width: 120px;
}

.removeButton {
  justify-content: end;
  margin-right: 10px;
}

/** buttons */
.videoItemButton {
  height: 2rem !important;
  width: 2rem !important;
  margin: 0px;
}
.material-design-icon__svg {
  /* padding-left: 2px; */
  height: 1rem !important;
  width: 1rem !important;
  /* margin-top: 1px !important; */
}

@media only screen and (max-width: 440px) {
  /** buttons */
  .videoItemButton {
    height: 1.6rem !important;
    width: 1.6rem !important;
    /* margin: 0 2px; */
  }
  .material-design-icon__svg {
    /* padding-left: 2px; */
    height: 0.8rem !important;
    width: 0.8rem !important;
    /* margin-top: 1px !important; */
  }
}
@media only screen and (max-width: 639px), only screen and (max-height: 740px) {
  .thumb-img {
    /* width: 160px;
    height: 90px; */
  }
}
@media only screen and (min-width: 992px) {
  .material-design-icon__svg {
    height: 0.7rem !important;
    width: 0.7rem !important;
    /* margin-top: 2px !important; */
  }
  .videoItemButton {
    height: 1.8rem !important;
    width: 1.8rem !important;
    /* margin: 0 2px; */
  }
}
@media only screen and (min-width: 1200px) {
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    /* margin-top: 2px !important; */
  }
  .videoItemButton {
    height: 2rem !important;
    width: 2rem !important;
  }
}
@media only screen and (min-width: 1920px) {
  .material-design-icon__svg {
    height: 1rem !important;
    width: 1rem !important;
    /* margin-top: 2px !important; */
  }
}
</style>
